import MinusIcon from "@/assets/icons/minus.svg";
import PlusIcon from "@/assets/icons/plus.svg";
import { useTranslations } from "next-intl";

type CateringShowDietsProps = {
  visible: boolean;
};

export const CateringDietListExpandButton = ({
  visible,
}: CateringShowDietsProps) => {
  const t = useTranslations("caterings");
  return (
    <>
      {!visible ? (
        <>
          <span data-pw="show-diets-button">{t("show_diets")}</span>{" "}
          <PlusIcon className="hidden md:block" />
        </>
      ) : (
        <>
          <span data-pw="hide-diets-button">{t("hide_diets")}</span>
          <MinusIcon className="hidden md:block" />
        </>
      )}
    </>
  );
};
